interface Props {
  strokeColor?: string;
}

export default function BorderedCircle({ strokeColor = 'white' }: Props) {
  return (
    <>
      <svg width="8" height="8" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="4" r="3" stroke={strokeColor} fill="transparent" strokeWidth="1" />
      </svg>
    </>
  );
}
